import classNames from 'classnames'
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import axios from 'axios';
import store, { IRootState } from '../../../../core/store';
import { RouteComponentProps } from 'react-router-dom'
import authApi from '../../../../core/api/auth-api'
import Button from '../../../../shared/Button/Button'
import TextField from '../../../../shared/TextField/TextField'
import MyNavigator from '../../../../route_names/navigation'
import CustomSelectAutoComplete from '../../../../shared/SelectAutoComplete/SelectAutoComplete'
import TimeSlider from './../../../../shared/Slider/Slider'
import FileUploadForm from '../../../../shared/FileUploadForm/FileUploadForm'
import vendorApi from '../../../../core/api/vendor-api'
import { VendorService } from '../../../../models/vendor'
import style from './EmpForm.module.scss'
import { InputAdornment } from '@material-ui/core'
import { Category } from '../../../../models/category'
import { Service } from '../../../../models/service';
import httpApi from '../../../../core/api/http-api';

interface Iprops {
    token: string
}

interface Istate {
    userName: string,
    fullName: string,
    password: string,
    cPassword: string,
    salonName: string,
    salonDescription: string,
    qualifications: string,
    facebookUrl: string,
    instagramUrl: string,
    twitterUrl: string,
    youtubeUrl: string,
    contactEmail: string,
    mobileNumber: string,
    bookingUrl: string,
    category: string,
    serviceType: string,
    subService: string,
    description: string,
    price: number,
    hours: string,
    minutes: string,
    subServicesData: any[],
}

interface Ierror {
    userNameErrorText: string,
    fullNameErrorText: string,
    passwordErrorText: string,
    cPasswordErrorText: string,
    salonNameErrorText: string,
    mobileNumberErrorText: string,
    contactEmailErrorText: string,
}

const formatMobile = (value: string): string => {
    const onlyNums: string = value.replace(/[^0-9]/g, '');
    let number: string = ''
    if (onlyNums.length < 10) {
        number = onlyNums
    }
    if (onlyNums.length === 10) {
        number = onlyNums.replace(
            /(\d{3})(\d{3})(\d{4})/,
            '($1) $2-$3'
        );

    }
    return number
}

const EmpForm: React.FC<Iprops> = (props) => {
    const Navigator = MyNavigator()
    const [state, setState] = useState<Istate>({
        userName: "",
        fullName: "",
        password: "",
        cPassword: "",
        salonName: "",
        salonDescription: "",
        qualifications: "",
        facebookUrl: "",
        instagramUrl: "",
        twitterUrl: "",
        youtubeUrl: "",
        contactEmail: "",
        mobileNumber: "",
        bookingUrl: "",
        category: '',
        serviceType: '',
        hours: '',
        minutes: '0',
        price: 0,
        description: '',
        subService: '',
        subServicesData: [],
    })
    const [error, setError] = useState<Ierror>({
        userNameErrorText: '',
        fullNameErrorText: '',
        passwordErrorText: '',
        cPasswordErrorText: '',
        salonNameErrorText: '',
        mobileNumberErrorText: '',
        contactEmailErrorText: '',
    })
    
    const [allServices, setAllServices] = useState<Service[]>([]);
    const [allCategories, setAllCategories] = useState<Category[]>([]);
    const [currentStep, setCurrentStep] = useState(0)
    const [selectedImageFiles, setSelectedImageFiles] = useState<File[]>([]);
    const [categoryFilter, setCategoryFilter] = useState<string[]>([]);
    // const [selectedCategory, setSelectedCategory] = useState<string>('');
    // const [selectedService, setSelectedService] = useState<string>('');
    const [filteredServices, setFilteredServices] = useState<Service[]>([]); // State for filtered services
    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
    const [selectedServiceId, setSelectedServiceId] = useState<number | null>(null);

    const fetchServices = async () => {
        try {
            const services = await httpApi.get('/Services');
            setAllServices(services.Services); // Assuming the response data is an array of services
        } catch (error) {
            console.error('Error fetching services:', error);
        }
    };

    const fetchCategories = async () => {
        try {
            const categories = await httpApi.get('/category/getallActive');
            setAllCategories(categories.Category); // Assuming the response data is an array of categories
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    };

    useEffect(() => {
        fetchCategories();
        fetchServices();
    }, []);

    useEffect(() => {
        if (selectedCategoryId) {
            const filtered = allServices.filter(service => service.category === selectedCategoryId);
            setFilteredServices(filtered);
        } else {
            setFilteredServices(allServices); // Reset if no category is selected
        }
    }, [selectedCategoryId, allServices]);

    const handleChange = (event: any) => {
        event.persist();
        const { name, value } = event.target;

        if (name === "email") {
            let text: string = value
            text = text.toLowerCase()
            setState(prevState => ({
                ...prevState,
                [name]: text
            }))
        }
        else if (name === "mobileNumber") {
            // Allow only digits after "+1"
            const onlyNums: string = value.replace(/[^0-9]/g, '');
            
            // Ensure the mobile number always starts with "+1"
            if (onlyNums.length <= 10) { // US numbers have 10 digits
                setState(prevState => ({
                    ...prevState,
                    mobileNumber: `${onlyNums}`
                }));
            }
        }
        else {
            setState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }

        handleError(name, value)

    }

    const handleError = (name: string, value: string) => {
        // Error handling logic here
    }

    const handleNext = async () => {
        let hasError = false;

        // Reset error states
        setError({
            userNameErrorText: '',
            fullNameErrorText: '',
            passwordErrorText: '',
            cPasswordErrorText: '',
            salonNameErrorText: '',
            mobileNumberErrorText: '',
            contactEmailErrorText: '',
        });

        if (currentStep === 0) {
            // Step 1 Validation
            // Validate User Name
            if (!state.userName) {
                setError(prev => ({ ...prev, userNameErrorText: 'User Name is required.' }));
                hasError = true;
            }

            // Validate Full Name
            if (!state.fullName) {
                setError(prev => ({ ...prev, fullNameErrorText: 'Full Name is required.' }));
                hasError = true;
            }

            // Validate Password
            if (!state.password) {
                setError(prev => ({ ...prev, passwordErrorText: 'Password is required.' }));
                hasError = true;
            }

            // Validate Confirm Password
            if (!state.cPassword) {
                setError(prev => ({ ...prev, cPasswordErrorText: 'Confirm Password is required.' }));
                hasError = true;
            }

            // Check if Password and Confirm Password match
            if (state.password !== state.cPassword) {
                setError(prev => ({ ...prev, cPasswordErrorText: 'Passwords do not match.' }));
                hasError = true;
            }

            // Check if Username is taken
            if (!hasError) {
                try {
                    const response = await authApi.isUsernameTaken(state.userName);
                    if (response === "") {
                        // Username is available, so we proceed to the next step
                        // Do nothing as going to the next step is handled
                    } else {
                        // Username is taken, show error message
                        setError(prev => ({ ...prev, userNameErrorText: 'Username is already taken.' }));
                        hasError = true;
                    }
                } catch (error) {
                    setError(prev => ({ ...prev, userNameErrorText: 'Error checking username. Please try again.' }));
                    hasError = true;
                }
            }

            if (hasError) {
                return;
            }
        } else if (currentStep === 1) {
            // Step 2 Validation
            // Validate Salon Name
            if (!state.salonName) {
                setError(prev => ({ ...prev, salonNameErrorText: 'Salon Name is required.' }));
                hasError = true;
            }

            // Validate Contact Email
            if (!state.contactEmail) {
                setError(prev => ({ ...prev, contactEmailErrorText: 'Contact Email is required.' }));
                hasError = true;
            }

            // Validate Mobile Number
            if (!state.mobileNumber || !/^\d{10}$/.test(state.mobileNumber)) {
                setError(prev => ({ ...prev, mobileNumberErrorText: 'Mobile Number must be a valid US number.' }));
                hasError = true;
            }

            // If there are errors, do not proceed to the next step
            if (hasError) {
                return;
            }

            // Check if Booking URL is filled
            if (state.bookingUrl.trim() !== "") {
                // Call handleSignUp if Booking URL is filled
                handleSignUp(new Event('submit'));
                return; // Prevent moving to Step 3
            }
        }

        // Proceed to the next step if no errors
        setCurrentStep((prevStep) => prevStep + 1);
    };

    const handleBack = () => {
        setCurrentStep((prevStep) => prevStep - 1);
    }

    const handleMinutesChange = (e: any,value:any) => {
        setState(prevState => ({
            ...prevState,
            minutes: value
        }))
    }

    const handleSignUp = async (event: any) => {
        event.preventDefault();

        let { userNameErrorText,
            fullNameErrorText,
            mobileNumberErrorText,
            passwordErrorText,
            cPasswordErrorText,
            salonNameErrorText,
            contactEmailErrorText
         } = error

        let data = {
            username: state.userName,
            full_name: state.fullName,
            mobile_no: '+1' + state.mobileNumber.replace(/[^0-9]/g, ''),
            password: state.password,
            salon_name: state.salonName,
            salon_description: state.salonDescription,
            qualifications: state.qualifications.trim() ? state.qualifications : null,
            facebook_url: state.facebookUrl.trim() ? state.facebookUrl : null,
            instagram_url: state.instagramUrl.trim() ? state.instagramUrl : null,
            twitter_url: state.twitterUrl.trim() ? state.twitterUrl : null,
            youtube_url: state.youtubeUrl.trim() ? state.youtubeUrl : null,
            contact_email: state.contactEmail,
            booking_url: state.bookingUrl.trim() ? state.bookingUrl : null,
            services_data: state.subServicesData
        }

        if (!passwordErrorText && !cPasswordErrorText && !userNameErrorText && !fullNameErrorText && !mobileNumberErrorText && !salonNameErrorText && !contactEmailErrorText) {
            try {
                await authApi.confirmUser(props.token, data, selectedImageFiles[0]);
                // await uploadProfilePicture();
                Navigator.pushNamed('/login')
            } catch (err: any) {
                setError({
                    ...error,
                    userNameErrorText: err.message,
                    passwordErrorText: err.message
                })
            }
        }
    }

    const uploadProfilePicture = async () => {
        if (!selectedImageFiles || selectedImageFiles.length === 0) return;

        try {
            const result = await compressImage(selectedImageFiles[0]);
            await vendorApi.uploadProfilePicture(result, selectedImageFiles[selectedImageFiles.length - 1].name);
            setSelectedImageFiles([]);
        } catch (e) {
            console.error(e);
        }
    };

    const compressImage = (image: any) => {
        return new Promise((resolve, reject) => {
            new Compressor(image, {
                quality: 0.6,
                success(result: any) {
                    return resolve(result);
                },
                error(err: any) {
                    return reject(err);
                },
            });
        });
    };

    const handleAddService = () => {
        const { subService, description, price, minutes } = state;
        const selectedService_Id = selectedServiceId ? selectedServiceId : selectedCategoryId;

        if (subService && description && price > 0 && parseInt(minutes) > 0) {
            setState(prevState => ({
                ...prevState,
                subServicesData: [
                    ...prevState.subServicesData,
                    { service_id: selectedService_Id, sub_service: subService, description, price, duration: minutes }
                ],
                subService: '',
                description: '',
                price: 0,
                minutes: '0'
            }));
        }
    };

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault(); // Prevent default form submission
    };

    const renderStep = () => {
        switch (currentStep) {
            case 0:
                return (
                    <div>
                        <TextField
                            name="userName"
                            onChange={handleChange}
                            error={!!error.userNameErrorText}
                            helperText={error.userNameErrorText}
                            value={state.userName}
                            label="User Name"
                        /><br /><br />
                        <TextField
                            name="fullName"
                            onChange={handleChange}
                            error={!!error.fullNameErrorText}
                            helperText={error.fullNameErrorText}
                            value={state.fullName}
                            label="Full Name"
                        /><br /><br />
                        <TextField
                            name="password"
                            onChange={handleChange}
                            error={!!error.passwordErrorText}
                            helperText={error.passwordErrorText}
                            value={state.password}
                            label="Password"
                            type="password"
                        /><br /><br />
                        <TextField
                            name="cPassword"
                            onChange={handleChange}
                            error={!!error.cPasswordErrorText}
                            helperText={error.cPasswordErrorText}
                            value={state.cPassword}
                            label="Confirm Password"
                            type="password"
                        />
                    </div>
                );
            case 1:
                return (
                    <div>
                        <TextField
                            name="salonName"
                            onChange={handleChange}
                            error={!!error.salonNameErrorText}
                            helperText={error.salonNameErrorText}
                            value={state.salonName}
                            label="Salon Name"
                        /><br /><br />
                        <TextField
                            name="salonDescription"
                            onChange={handleChange}
                            value={state.salonDescription}
                            label="Salon Description"
                        /><br /><br />
                        <TextField
                            name="qualifications"
                            onChange={handleChange}
                            value={state.qualifications}
                            label="Qualifications"
                        /><br /><br />
                        <TextField
                            name="facebookUrl"
                            onChange={handleChange}
                            value={state.facebookUrl}
                            label="Facebook URL"
                        /><br /><br />
                        <TextField
                            name="instagramUrl"
                            onChange={handleChange}
                            value={state.instagramUrl}
                            label="Instagram URL"
                        /><br /><br />
                        <TextField
                            name="twitterUrl"
                            onChange={handleChange}
                            value={state.twitterUrl}
                            label="Twitter URL"
                        /><br /><br />
                        <TextField
                            name="youtubeUrl"
                            onChange={handleChange}
                            value={state.youtubeUrl}
                            label="YouTube URL"
                        /><br /><br />
                        <TextField
                            name="contactEmail"
                            onChange={handleChange}
                            error={!!error.contactEmailErrorText}
                            helperText={error.contactEmailErrorText}
                            value={state.contactEmail}
                            label="Contact Email"
                        /><br /><br />
                        <TextField
                            name="mobileNumber"
                            onChange={handleChange}
                            error={!!error.mobileNumberErrorText}
                            helperText={error.mobileNumberErrorText}
                            value={state.mobileNumber}
                            label="Mobile Number"
                            InputProps={{
                                startAdornment: <InputAdornment position="start">+1</InputAdornment>,
                            }}
                        /><br /><br />
                        <TextField
                            name="bookingUrl"
                            onChange={handleChange}
                            value={state.bookingUrl}
                            label="Booking URL"
                        /><br /><br />
                        <FileUploadForm
                            files={selectedImageFiles}
                            onChange={(files: any) => setSelectedImageFiles(files)}
                        />
                    </div>
                );
            case 2:
                return (
                    <div>
                        <h3>Service Details</h3>
                        <CustomSelectAutoComplete
                            label="Category"
                            onChange={(value: string) => {
                                const selectedCategory = allCategories.find(category => category.name === value);
                                setSelectedCategoryId(selectedCategory ? selectedCategory.id : null);
                            }}
                            data={allCategories.map(category => category.name)}
                            disabled={state.subServicesData.length > 0}
                        /><br /><br />
                        <CustomSelectAutoComplete
                            label="Service"
                            onChange={(value: string) => {
                                const selectedService = allServices.find(service => service.type === value);
                                setSelectedServiceId(selectedService ? selectedService.id : null);
                            }}
                            data={filteredServices.map(service => service.type)}
                            disabled={!selectedCategoryId || state.subServicesData.length > 0}
                        /><br /><br />
                        <TextField
                            onChange={(event) => setState(prevState => ({
                                ...prevState,
                                subService: event.target.value
                            }))}
                            value={state.subService}
                            name="subService"
                            className='full-width'
                            autoComplete="off"
                            fullWidth
                            label="Service Type"
                            variant="outlined" /><br /><br />
                        <TextField
                            onChange={(event) => setState(prevState => ({
                                ...prevState,
                                description: event.target.value
                            }))}
                            value={state.description}
                            name="description"
                            className='full-width'
                            autoComplete="off"
                            fullWidth
                            multiline
                            label="Description"
                            variant="outlined" /><br /><br />
                        <TextField
                            onChange={(event) => setState(prevState => ({
                                ...prevState,
                                price: parseFloat(event.target.value) || 0
                            }))}
                            value={state.price}
                            name="price"
                            InputProps={{
                                inputProps: {
                                    min: 0
                                },
                                startAdornment:
                                    <InputAdornment position="start">
                                        $
                                    </InputAdornment>
                            }}
                            type="number"
                            className='full-width'
                            autoComplete="off"
                            fullWidth
                            label="Price"
                            variant="outlined" /><br /><br />
                        <TimeSlider minutes={state.minutes} handleMinutesChange={handleMinutesChange}/>
                        <Button onClick={handleAddService} variant="contained" color="primary">
                            Add Service
                        </Button>

                        <div>
                            {state.subServicesData.length > 0 && (
                                <div>
                                    <br /><br />
                                    <h4><b>Added Services</b></h4>
                                    {state.subServicesData.map((item, index) => (
                                        <div key={index}>
                                            <p>{item.sub_service} &nbsp;&nbsp;&nbsp; {item.description} &nbsp;&nbsp;&nbsp; ${item.price} &nbsp;&nbsp;&nbsp; {item.duration} min</p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    }

    return (
        <div>
            <div className={style.progressContainer}>
                <div className={style.progressBar}>
                    {[0, 1, 2].map((step) => (
                        <div key={step} className={style.step}>
                            <div className={`${style.circle} ${currentStep >= step ? style.active : ''}`}>
                                {step+1}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <form className={style.container} onSubmit={handleFormSubmit}>
                <div className={style.progressBar}>
                    <div style={{ width: `${((currentStep + 1) / 3) * 100}%` }} />
                </div>
                {renderStep()}
                <div className={style.actions}>
                    {currentStep > 0 && (
                        <Button onClick={handleBack} variant="contained" color="secondary">
                            Back
                        </Button>
                    )}
                    {currentStep < 2 ? (
                        <Button type="button" onClick={handleNext} variant="contained" color="primary">
                            Next
                        </Button>
                    ) : (
                        <Button type="submit" variant="contained" color="primary" onClick={handleSignUp}>
                            Sign Up
                        </Button>
                    )}
                </div>
            </form>
        </div>
    )
}

export default EmpForm
